import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import * as translator from '../../../../../utils/translator';

interface PlanActiveStateProps {
	firstName: string;
	language: string;
	isMonthlyPlan?: boolean;
}

const PlanActiveState: React.FC<PlanActiveStateProps> = ({ firstName, language, isMonthlyPlan }) => {
	const navigate = useNavigate();

	return (
		<div id="care-profile-hero" className="w-full flex flex-col items-center gap-y-4">
			<div id="care-profile-breadcrumb" className="w-full flex items-center">
				<button
					id="care-profile-breadcrumb-back"
					type="button"
					aria-label="Back"
					onClick={() => navigate(-1)}
					className="lg:hidden shrink-0 flex items-center justify-center w-6 h-6 text-care-plus-heading border-none bg-transparent"
				>
					<FiChevronLeft size={24} />
				</button>
				<div className="flex-1 flex items-center justify-center gap-x-1">
					<span className="font-serif-display italic text-care-plus-orange text-[32px] leading-[48px]">{isMonthlyPlan ? translator.translate(language, 'my_account', 'CarePlus/monthlyPlan/label') : 'Care+'}</span>
					<span className="pt-1 text-base leading-6 text-care-plus-heading">
						{translator.translate(language, 'my_account', 'CareProfile/Hero/EyebrowSuffix')}
					</span>
				</div>
			</div>
			<div id="care-profile-welcome-header" className="w-full flex flex-col items-center gap-y-2 text-center">
				<h1 className="text-[26px] font-medium text-care-plus-heading">
					{translator.translate(language, 'my_account', 'CareProfile/Hero/WelcomePrefix')}{' '}
					<span className="font-serif-display italic text-care-plus-orange text-[32px]">{firstName}</span>
				</h1>
				<p id="care-profile-hero-subtitle" className="text-base text-[#62544d]">
					{translator.translate(language, 'my_account', 'CareProfile/Hero/Subtitle')}
				</p>
			</div>
		</div>
	);
};

export default PlanActiveState;
